/** Human-readable labels for structured question fields shown in the diff view */
export const QUESTION_FIELD_LABELS: Record<string, string> = {
  question: 'Question Text',
  question_type: 'Question Type',
  section: 'Section',
  question_details: 'Details / Instructions',
  options: 'Options',
  required: 'Required',
  attachment_required: 'Attachment Required',
  char_limit: 'Character Limit',
  word_limit: 'Word Limit',
  conditional_on: 'Conditional Display',
  depends_on: 'Depends On',
  has_other_text_field: 'Has "Other" Text Field',
}
